import {
  CheckoutStage,
  CheckoutStages,
} from "../../services/models/checkout.models";

const ShoppingCartPath = "";
const CheckoutPath = "/utsjekk";

const normalizePath = (path: string): string => {
  return path.replace(/\/$/, "");
};

export const getRouteStage = (
  path: string,
): CheckoutStage | undefined => {
  const normalizedPath = normalizePath(path);

  if (normalizedPath === ShoppingCartPath) {
    return CheckoutStages.ShoppingCart;
  }

  if (normalizedPath === CheckoutPath) {
    return CheckoutStages.Checkout;
  }

  return undefined;
};

export const buildCheckoutNavigation = (
  currentPath: string,
  stage: CheckoutStage,
): { path: string } | null => {
  if (stage === CheckoutStages.InitialPageLoad || stage === CheckoutStages.PlacingOrder) {
    return null;
  }

  const path = stage === CheckoutStages.ShoppingCart ? ShoppingCartPath : CheckoutPath;
  const normalizedCurrentPath = normalizePath(currentPath);

  if (normalizedCurrentPath === path) {
    return null;
  }

  return { path };
};

// PlacingOrder is a one-way, transient stage - a bfcache-restored `pageshow`
// (browser Back after the window.location.href redirect away) can freeze the
// page there forever with no way to progress, since the reservation/payment
// already completed. Any other stage is left untouched.
export const resolveStageAfterBfcacheRestore = (
  stage: CheckoutStage,
): CheckoutStage | null => {
  return stage === CheckoutStages.PlacingOrder ? CheckoutStages.ShoppingCart : null;
};
